<template>
  <div v-if="$auth.check()">

    <h1>Parceiros v1.0</h1>

    <v-row class="mt-2">

      <v-col cols="12" sm="4">
        <v-card outlined link @click="go('/lead')">
          <v-card-title>
            <v-icon left color="primary">mdi-account-circle</v-icon>
            Leads
          </v-card-title>
          <v-card-subtitle>{{ periodText }}</v-card-subtitle>
          <v-card-text>
            <div class="text-h3 text--primary" v-if="leads">{{ leads.length }}</div>
            <v-progress-circular indeterminate size="32" color="primary" v-else></v-progress-circular>
            <div class="mt-4" v-if="leads">
              <v-chip small class="mr-1" color="warning">{{ leadsByStatus.visitante }} visitantes</v-chip>
              <v-chip small class="mr-1" color="primary">{{ leadsByStatus.cliente }} clientes</v-chip>
              <v-chip small color="success">{{ leadsByStatus.fa }} fãs</v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="4">
        <v-card outlined link @click="go('/nps')">
          <v-card-title>
            <v-icon left color="primary">mdi-speedometer</v-icon>
            NPS
          </v-card-title>
          <v-card-subtitle>{{ periodText }}</v-card-subtitle>
          <v-card-text>
            <div class="text-h3 text--primary" v-if="nps">{{ nps.length }}</div>
            <v-progress-circular indeterminate size="32" color="primary" v-else></v-progress-circular>
            <div class="mt-4" v-if="nps">
              <v-chip small>nota média {{ npsAverage }}</v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="4">
        <v-card outlined link @click="go('/partner')">
          <v-card-title>
            <v-icon left color="primary">mdi-handshake</v-icon>
            Parceiros
          </v-card-title>
          <v-card-subtitle>Cadastrados</v-card-subtitle>
          <v-card-text>
            <div class="text-h3 text--primary" v-if="partners">{{ partners.length }}</div>
            <v-progress-circular indeterminate size="32" color="primary" v-else></v-progress-circular>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>

  </div>
</template>

<script>
import api from "../api/index.js";
import router from "../router/index.js";
export default {
  data: function () {
    var now = new Date();
    return {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      leads: null,
      nps: null,
      partners: null,
      months: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    };
  },
  computed: {
    periodText: function () {
      return this.months[this.month - 1] + " / " + this.year;
    },
    leadsByStatus: function () {
      var ret = { visitante: 0, cliente: 0, fa: 0 };
      if (!this.leads) return ret;
      for (var i = 0; i < this.leads.length; i++) {
        var status = this.leads[i].status;
        if (status == 1) {
          ret.visitante++;
        } else if (status == 2) {
          ret.cliente++;
        } else if (status == 3) {
          ret.fa++;
        }
      }
      return ret;
    },
    npsAverage: function () {
      if (!this.nps) return "-";
      var sum = 0;
      var count = 0;
      for (var i = 0; i < this.nps.length; i++) {
        var score = parseFloat(this.nps[i].scoreReceived);
        if (!isNaN(score)) {
          sum += score;
          count++;
        }
      }
      if (count == 0) return "-";
      return (sum / count).toFixed(1).replace(".", ",");
    },
  },
  created: function () {
    this.count("/lead", "leads");
    this.count("/nps", "nps");
    this.count("/partner", "partners");
  },
  methods: {
    count: function (path, target) {
      var me = this;
      var token = localStorage.getItem("token");
      var params = {};
      if (path != "/partner") {
        params.year = me.year;
        params.month = me.month;
      }
      api
        .get(path, {
          params: params,
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me[target] = response.data;
        })
        .catch(function () {
          console.log("count fail");
        });
    },
    go: function (path) {
      router.push({ path: path });
    },
  },
};
</script>
